<template>
  <div>
    <Header />
    <Nav />
    <div class="body pb70">
      <div class="menu bgc"></div>
      <div class="container">
        <div class="newsBox">
          <div class="top">
            <div class="title">【溯源优才APP】版本更新记录</div>
            <div class="subTitle">&nbsp;&nbsp;Version Update Records</div>
          </div>
          <div class="content">
            <div class="vList">
              <div class="vItem" v-for="item in list" :key="item.id">
                <div class="c1">
                  <div class="vNum">版本：{{ item.releaseNum }}</div>
                  <div class="vDate">
                    更新于{{ item.createDate | parseTime("{y}-{m}-{d}") }}
                  </div>
                </div>
                <div class="c3">
                  <i class="circle"></i>
                  <!-- <div class="vTitle">更新类型：Andriod、Ios</div> -->
                  <div class="vTitle">更新内容：</div>
                  <div class="vContent" v-html="item.content"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "../../components/Footer.vue";
import Header from "../../components/Header.vue";
import Nav from "../../components/Nav.vue";
import { versions } from "@/api/version";

export default {
  components: { Header, Footer, Nav },
  data() {
    return {
      list: undefined
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      versions().then(res => {
        // console.log(res);
        this.list = res.data.d;
      });
    }
  }
};
</script>

<style scoped lang="scss">
.body {
  padding-bottom: 70px;
  display: inline-block;
  width: 100%;
  background-color: #f0f2f5;
  .newsBox {
    padding: 60px;
    margin: 40px 0 0px 0;
    line-height: 30px;
    background: #fff;
    font-size: 14px;
    color: #6e6e6e;
    .top {
      border-bottom: 3px solid #f0f2f5;
      margin-bottom: 50px;
      .title {
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #393939;
        // line-height: 41px;
      }
      .subTitle {
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #a2a2a2;
        // line-height: 41px;
        margin-bottom: 20px;
      }
    }
    .content {
      display: flex;
      .vList {
        .vItem {
          display: flex;

          &:last-child {
            .c3 {
              border-left: 3px solid #fff;
            }
          }
          .c1 {
            .vNum {
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #3a61b1;
              line-height: 16px;
            }
            .vDate {
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #a2a2a2;
              margin-top: 5px;
            }
          }
          .c2 {
            position: relative;
          }
          .c3 {
            flex: 1;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #393939;
            border-left: 3px solid #f0f2f5;
            padding-left: 42px;
            position: relative;
            margin-left: 38px;
            padding-bottom: 50px;
            .circle {
              border-radius: 50%;
              width: 14px;
              height: 14px;
              display: inline-block;
              border: 2px solid #29447c;
              position: absolute;
              background: #fff;
              left: -8px;
              box-sizing: border-box;
            }
            .vTitle {
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: 600;
              color: #393939;
              line-height: 16px;
              margin-bottom: 14px;
              &:nth-child(2) {
                margin-bottom: 23px;
              }
            }
            .vContent {
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #6e6e6e;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/version/index.vue